// [init]

export default {


	namespaced: true,

	state: {

	},

	mutations: {

	},

	actions: {

		/* 
		*  /GET/:id customer-credits API
		*  Get a single customer-credit from the server
		*  @params: identifier (String)
		*  @return: Object
		*/
		getSingleCustomersCredits( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/customers-credits/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Customers-credits.js